// src/util/metaPixel.js
/**
 * Meta(인스타그램) 픽셀 — 광고가 "누가 실제로 공고를 등록했는지" 배우게 한다(2026-10-21 광고 퍼널).
 *  우리 이용 로그(util/appAnalytics)와 별개로, 광고 성과용 표준 이벤트만 Meta 로 보낸다.
 *
 *  - PIXEL_ID 가 비어 있으면 아무것도 하지 않는다(스크립트도 안 받는다). Meta 이벤트 관리자에서 만든 ID 를 넣으면 켜진다.
 *  - 앱 안 웹페이지에서는 끈다 — 광고 유입은 인스타 앱 안 브라우저·사파리·크롬이고, 앱 사용자는 광고 대상이 아니다.
 *  - 개인정보: 이름·연락처·공고 내용은 보내지 않는다. 이벤트 이름과 공고 종류(content_category)만.
 *  ★ 로그 때문에 화면이 실패하면 안 된다 — 모든 진입점은 예외를 삼킨다.
 */
import { hasNativeBridge, detectRuntime, Runtime } from "util/userAgent";

export const PIXEL_ID = "1346563150740015";

let loaded = false;

const enabled = () => {
  if (!PIXEL_ID || typeof window === "undefined") return false;
  if (hasNativeBridge()) return false;
  const rt = detectRuntime();
  return rt !== Runtime.IOS_WEBVIEW && rt !== Runtime.ANDROID_WEBVIEW;
};

/** Meta 표준 설치 코드(fbevents.js) — 처음 부를 때 한 번만 넣는다. */
function load() {
  if (loaded) return true;
  if (!enabled()) return false;
  try {
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    loaded = true;
  } catch (e) {
    return false;
  }
  return true;
}

/** 표준 이벤트(PageView·ViewContent·Lead·CompleteRegistration). eventId 는 서버 전송과 중복을 거르는 값. */
export function pixelTrack(name, params, eventId) {
  try {
    if (!load()) return;
    if (eventId) window.fbq("track", name, params || {}, { eventID: String(eventId) });
    else window.fbq("track", name, params || {});
  } catch (e) { /* noop */ }
}

/** 맞춤 이벤트(StartForm 등). */
export function pixelTrackCustom(name, params) {
  try {
    if (!load()) return;
    window.fbq("trackCustom", name, params || {});
  } catch (e) { /* noop */ }
}

/** 화면 이동마다 — AppRouter 가 부른다. */
export function pixelPageView() {
  pixelTrack("PageView");
}
